module.exports = __webpack_public_path__ + "img/hylogo.f4c5b3d8.png";